module.exports = __webpack_public_path__ + "static/media/fitness_factory.ef0116ea.webp";